var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row site-section-wrapper"},[_c('div',{staticClass:"col-4"},[_c('ProjectDetails')],1),_c('div',{staticClass:"col-8 right-col"},[_c('ProjectMap')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }